import React from "react";
import "./ECLPageWrapper.css";

export default function ECLPageWrapper(props) {
   return (
      <div className="ecl-page-wrapper">
         <div className="page-content-container" id="page-scroll-container">
            {props.children}
         </div>
      </div>
   );
}
